import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "sss-top-wrapper" }
const _hoisted_5 = { class: "sss-top-text" }
const _hoisted_6 = {
  href: "https://www.kanshin-hiroba.jp/social-security-system",
  class: "sss-text-link",
  target: "_blank"
}
const _hoisted_7 = {
  class: "sss-top-button-link",
  href: "https://www.kanshin-hiroba.jp/social-security-system",
  target: "_blank"
}
const _hoisted_8 = { class: "sss-top-attention" }
const _hoisted_9 = { class: "sss-search-wrapper" }
const _hoisted_10 = { class: "sss-search-title" }
const _hoisted_11 = { class: "sss-search-text" }
const _hoisted_12 = { class: "sss-search-links" }
const _hoisted_13 = { class: "sss-search-links-top" }
const _hoisted_14 = {
  href: "https://www.kanshin-hiroba.jp/0-5",
  target: "_blank"
}
const _hoisted_15 = ["alt"]
const _hoisted_16 = {
  href: "https://www.kanshin-hiroba.jp/6-12",
  target: "_blank"
}
const _hoisted_17 = ["alt"]
const _hoisted_18 = { class: "sss-search-links-under" }
const _hoisted_19 = {
  href: "https://www.kanshin-hiroba.jp/13-18",
  target: "_blank"
}
const _hoisted_20 = ["alt"]
const _hoisted_21 = {
  href: "https://www.kanshin-hiroba.jp/18-",
  target: "_blank"
}
const _hoisted_22 = ["alt"]

import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose07-01";
const activeMenu = "welfare";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, { "active-menu": activeMenu }),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("welfare_title")), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("welfare_msg_description_1")), 1),
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("welfare_link_kanshin_hiroba_welfare")), 1),
              _cache[1] || (_cache[1] = _createElementVNode("img", { src: "/server/necs/images/open_link.png" }, null, -1))
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("welfare_msg_description_2")), 1)
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            class: "sss-top-img",
            src: "/server/necs/images/seido_img01.png"
          }, null, -1)),
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("welfare_link_search_welfare")), 1),
            _cache[2] || (_cache[2] = _createElementVNode("img", { src: "/server/necs/images/new-tab_icon20260804.png" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("welfare_msg_attention")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              src: "/server/necs/images/search_icon.svg",
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("welfare_msg_search_by_age")), 1)
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("welfare_msg_search_by_age_description")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, [
                _createElementVNode("img", {
                  src: "/server/necs/images/sss_search_img_0to5.png",
                  alt: _ctx.$t('welfare_alt_search_by_age_0to5')
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("a", _hoisted_16, [
                _createElementVNode("img", {
                  src: "/server/necs/images/sss_search_img_6to12.png",
                  alt: _ctx.$t('welfare_alt_search_by_age_6to12')
                }, null, 8, _hoisted_17)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", _hoisted_19, [
                _createElementVNode("img", {
                  src: "/server/necs/images/sss_search_img_13to18.png",
                  alt: _ctx.$t('welfare_alt_search_by_age_13to18')
                }, null, 8, _hoisted_20)
              ]),
              _createElementVNode("a", _hoisted_21, [
                _createElementVNode("img", {
                  src: "/server/necs/images/sss_search_img_over18.png",
                  alt: _ctx.$t('welfare_alt_search_by_age_over18')
                }, null, 8, _hoisted_22)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(Footer, { "scroll-target": componentId })
    ])
  ]))
}
}

})